import type { ContentKind } from "#public"

import { ContentRenderer } from "../types/ContentRenderer"
import { RecordByPrimaryKey } from "../utils/RecordByPrimaryKey"

export const ContentKindList = RecordByPrimaryKey<ContentKind>([
  { id: ContentRenderer.BOOK, name: "CONTENT_BOOK" },
  { id: ContentRenderer.BOX, name: "CONTENT_BOX" },
  { id: ContentRenderer.DEPLIANT, name: "CONTENT_DEPLIANT" },
  { id: ContentRenderer.NOTEPAD_BLANK, name: "CONTENT_NOTEPAD_BLANK" },
  { id: ContentRenderer.NOTEPAD_LINED, name: "CONTENT_NOTEPAD_LINED" },
  { id: ContentRenderer.NOTEPAD_SQUARED, name: "CONTENT_NOTEPAD_SQUARED" },
  { id: ContentRenderer.NOTEPAD_DOTTED, name: "CONTENT_NOTEPAD_DOTTED" },
  { id: ContentRenderer.NOTEPAD_LINED_8, name: "CONTENT_NOTEPAD_LINED_8" },
  { id: ContentRenderer.NOTEPAD_SQUARED_10, name: "CONTENT_NOTEPAD_SQUARED_10" },
  { id: ContentRenderer.NOTEPAD_MILLIMETER, name: "CONTENT_NOTEPAD_MILLIMETER" },
  { id: ContentRenderer.CALENDAR_MONTH, name: "CONTENT_CALENDAR_MONTH" },
  { id: ContentRenderer.CALENDAR_SPREAD, name: "CONTENT_CALENDAR_SPREAD" },
  { id: ContentRenderer.CALENDAR_YEAR, name: "CONTENT_CALENDAR_YEAR" },
  { id: ContentRenderer.CALENDAR_AKINDEZ, name: "CONTENT_CALENDAR_AKINDEZ" },
  { id: ContentRenderer.CALENDAR_AKURA, name: "CONTENT_CALENDAR_AKURA" },
  { id: ContentRenderer.CALENDAR_BELWE, name: "CONTENT_CALENDAR_BELWE" },
  { id: ContentRenderer.CALENDAR_CLAN, name: "CONTENT_CALENDAR_CLAN" },
  { id: ContentRenderer.CALENDAR_DASH, name: "CONTENT_CALENDAR_DASH" },
  { id: ContentRenderer.CALENDAR_DUBIEL, name: "CONTENT_CALENDAR_DUBIEL" },
  { id: ContentRenderer.CALENDAR_EAVES, name: "CONTENT_CALENDAR_EAVES" },
  { id: ContentRenderer.CALENDAR_HAMURZ, name: "CONTENT_CALENDAR_HAMURZ" },
  { id: ContentRenderer.CALENDAR_HOOGE, name: "CONTENT_CALENDAR_HOOGE" },
  { id: ContentRenderer.CALENDAR_INTERSTATE, name: "CONTENT_CALENDAR_INTERSTATE" },
  { id: ContentRenderer.CALENDAR_KAUSHAN, name: "CONTENT_CALENDAR_KAUSHAN" },
  { id: ContentRenderer.CALENDAR_KEBBY, name: "CONTENT_CALENDAR_KEBBY" },
  { id: ContentRenderer.CALENDAR_LATO, name: "CONTENT_CALENDAR_LATO" },
  { id: ContentRenderer.CALENDAR_MADISON, name: "CONTENT_CALENDAR_MADISON" },
  { id: ContentRenderer.CALENDAR_MILO, name: "CONTENT_CALENDAR_MILO" },
  { id: ContentRenderer.CALENDAR_NELSON, name: "CONTENT_CALENDAR_NELSON" },
  { id: ContentRenderer.CALENDAR_RALEWAY, name: "CONTENT_CALENDAR_RALEWAY" },
  { id: ContentRenderer.CALENDAR_ROBOTO, name: "CONTENT_CALENDAR_ROBOTO" },
  { id: ContentRenderer.CALENDAR_RODDENBERRY, name: "CONTENT_CALENDAR_RODDENBERRY" },
  { id: ContentRenderer.CALENDAR_STYMIE, name: "CONTENT_CALENDAR_STYMIE" },
  { id: ContentRenderer.CALENDAR_TRIXIE, name: "CONTENT_CALENDAR_TRIXIE" },
  { id: ContentRenderer.CALENDAR_VINNIE, name: "CONTENT_CALENDAR_VINNIE" },
  { id: ContentRenderer.CALENDAR_WONDERWALL, name: "CONTENT_CALENDAR_WONDERWALL" },
  { id: ContentRenderer.AGENDA_WEEKLY, name: "CONTENT_AGENDA_WEEKLY" },
  { id: ContentRenderer.AGENDA_DAILY, name: "CONTENT_AGENDA_DAILY" },
  { id: ContentRenderer.AGENDA_ALTAIR, name: "CONTENT_AGENDA_ALTAIR" },
  { id: ContentRenderer.AGENDA_KIONA, name: "CONTENT_AGENDA_KIONA" },
  { id: ContentRenderer.AGENDA_KIONA_DAILY, name: "CONTENT_AGENDA_KIONA_DAILY" },
  { id: ContentRenderer.AGENDA_LEIXO, name: "CONTENT_AGENDA_LEIXO" },
  { id: ContentRenderer.AGENDA_MUNA, name: "CONTENT_AGENDA_MUNA" },
  { id: ContentRenderer.AGENDA_PAPYRUS, name: "CONTENT_AGENDA_PAPYRUS" },
  { id: ContentRenderer.AGENDA_PERPETUAL, name: "CONTENT_AGENDA_PERPETUAL" },
  { id: ContentRenderer.AGENDA_PERPETUAL_DAILY, name: "CONTENT_AGENDA_PERPETUAL_DAILY" },
  { id: ContentRenderer.PLANNER_WEEKLY, name: "CONTENT_PLANNER_WEEKLY" },
  { id: ContentRenderer.PLANNER_PERPETUAL, name: "CONTENT_PLANNER_PERPETUAL" },
  { id: ContentRenderer.PLANNER_ALBERTUS, name: "CONTENT_PLANNER_ALBERTUS" },
  { id: ContentRenderer.PLANNER_LEXICON, name: "CONTENT_PLANNER_LEXICON" },
  { id: ContentRenderer.PLANNER_LUBALIN, name: "CONTENT_PLANNER_LUBALIN" },
  { id: ContentRenderer.COUNTERFOIL, name: "CONTENT_COUNTERFOIL" },
] as const)
